import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const MobileBottomNav = ({ activePage, setActivePage, theme, setTheme, user, handleLogout, showAddModal }) => {
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const navItems = [
    { id: 'dashboard', icon: '🏠', label: 'Home' },
    { id: 'expenses', icon: '💳', label: 'Expenses' },
    { id: 'insights', icon: '📊', label: 'Insights' },
  ];

  const handleNavClick = (pageId) => {
    setActivePage(pageId);
  };

  const handleProfileClick = () => {
    setShowProfileMenu(true);
  };

  const closeProfileMenu = () => {
    setShowProfileMenu(false);
  };

  return (
    <>
      {/* Bottom Navigation */}
      <nav className="mobile-bottom-nav">
        <div className="mobile-bottom-nav__content">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`mobile-bottom-nav__item ${
                activePage === item.id ? 'mobile-bottom-nav__item--active' : ''
              }`}
              onClick={() => handleNavClick(item.id)}
            >
              <span className="mobile-bottom-nav__icon">{item.icon}</span>
              <span className="mobile-bottom-nav__label">{item.label}</span>
            </button>
          ))}
          
          {/* Add Button - Instagram Style */}
          <button
            className="mobile-bottom-nav__add"
            onClick={showAddModal}
            aria-label="Add expense"
          >
            +
          </button>

          {/* Profile Button */}
          <button
            className={`mobile-bottom-nav__item ${
              showProfileMenu ? 'mobile-bottom-nav__item--active' : ''
            }`}
            onClick={handleProfileClick}
          >
            <span className="mobile-bottom-nav__icon">👤</span>
            <span className="mobile-bottom-nav__label">Profile</span>
          </button>
        </div>
      </nav>

      {/* Profile Menu Overlay */}
      <AnimatePresence>
        {showProfileMenu && (
          <>
            <motion.div
              className="mobile-menu-overlay mobile-menu-overlay--active"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={closeProfileMenu}
            />
            <motion.aside
              className="mobile-menu-slide mobile-menu-slide--active"
              initial={{ x: 300 }}
              animate={{ x: 0 }}
              exit={{ x: 300 }}
              transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            >
              {/* Header */}
              <div className="mobile-menu-slide__header">
                <h2 className="mobile-menu-slide__title">Profile</h2>
                <button
                  className="mobile-menu-slide__close"
                  onClick={closeProfileMenu}
                  aria-label="Close menu"
                >
                  ✕
                </button>
              </div>

              {/* Content */}
              <div className="mobile-menu-slide__content">
                {/* User Info */}
                <div className="mobile-menu-slide__user">
                  <div className="mobile-menu-slide__avatar">
                    {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                  </div>
                  <div className="mobile-menu-slide__userinfo">
                    <div className="mobile-menu-slide__username">{user?.name || 'User'}</div>
                    <div className="mobile-menu-slide__useremail">{user?.email || 'user@example.com'}</div>
                  </div>
                </div>

                {/* Menu Items */}
                <div className="mobile-menu-slide__section">
                  <div className="mobile-menu-slide__section-title">Settings</div>
                  <button
                    className="mobile-menu-slide__item mobile-menu-slide__item--theme"
                    onClick={() => {
                      setTheme(theme === 'dark' ? 'light' : 'dark');
                      closeProfileMenu();
                    }}
                  >
                    <span className="mobile-menu-slide__item-icon">
                      {theme === 'dark' ? '☀️' : '🌙'}
                    </span>
                    <span className="mobile-menu-slide__item-text">
                      {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
                    </span>
                  </button>
                </div>

                <div className="mobile-menu-slide__divider" />

                <div className="mobile-menu-slide__section">
                  <div className="mobile-menu-slide__section-title">Account</div>
                  <button
                    className="mobile-menu-slide__item mobile-menu-slide__item--logout"
                    onClick={() => {
                      handleLogout();
                      closeProfileMenu();
                    }}
                  >
                    <span className="mobile-menu-slide__item-icon">🚪</span>
                    <span className="mobile-menu-slide__item-text">Logout</span>
                  </button>
                </div>
              </div>
            </motion.aside>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default MobileBottomNav;
